import type { Filter } from '../../Entities/Search/SearchFilters/Filter.entity';

const isAnyPriceType = (filterKey: string) =>
  filterKey.startsWith('price') || filterKey.startsWith('monthly-price');

export const hasPriceRangeForPath = (rangeFltr: Filter, partnerFltr?: Filter) => {
  if (!isAnyPriceType(rangeFltr.id)) return false;

  const scenario1 =
    rangeFltr.id.endsWith('__gte') && rangeFltr.value === '0' && Number(partnerFltr?.value) > 0;
  const scenario2 =
    rangeFltr.id.endsWith('__lte') &&
    Number(rangeFltr.value) > 0 &&
    (!partnerFltr?.value || partnerFltr.value === '0');

  return scenario1 || scenario2;
};
